import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		isLoggedIn: !!localStorage.getItem('status'),
		id: !!localStorage.getItem('id'),
		token: !!localStorage.getItem('token'),
		usertype: !!localStorage.getItem('usertype'),
		isClient: !!localStorage.getItem('isClient'),
		isSeller: !!localStorage.getItem('isSeller'),
		seller: !!localStorage.getItem('seller'),
		isBranch: !!localStorage.getItem('isBranch')
	},
	mutations: {
		loginUser(state) {
			state.isLoggedIn = true
		},
		Client(state) {
			state.isClient = true
			state.usertype = Client
		},
		Seller(state) {
			state.isSeller = true
			state.usertype = Seller
		},

		completedUser(state) {
			state.complete = true
		},

		logoutUser(state) {
			state.isLoggedIn = false
			
		}

	}

})